import { createContext, useContext } from 'react'
import { type CallingStore } from '../store/CallingStore'

export const CallingContext = createContext<CallingStore | null>(null)

export const useCallingContext = () => {
  const context = useContext(CallingContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with CallingContext')

  return context
}
